import { Component, OnInit } from '@angular/core';
import { TrsEventsService } from 'src/app/services/trsevents.service';
import { AppConfig } from 'src/app/services/app.config.services';
import { LogUpload } from 'src/app/utils/log-upload';
import { AuditService } from 'src/app/services/audit.service';
import { toggleNotificationSoundSetting } from 'src/app/utils/sound';
import { TranslocoService } from '@ngneat/transloco';
import { ISupervisorInit } from 'src/app/interfaces/agent.interface';
import { SupervisorService, Themes } from 'src/app/services/supervisor.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass']
})

export class HeaderComponent implements OnInit {
  teams: any;
  isNotificationSoundIconVisible = true;
  notification = true;
  userMode = "supervisor";
  userName: any;
  supervisorConnectivityStatus = false;
  showSuperAdminIcon = false;
  appConfig = AppConfig;
  currentProfile = "supervisor";
  dashboardView = false;
  gamificationView = false;
  isAllDataLoaded: boolean = false;

  incomingCall = false;

  logUploader: LogUpload = new LogUpload("HeaderComponent");
  showLogout: boolean = false;

  dashboardLabel: string = "";
  gamificationLabel: string = "";
  superadminLabel: string = "";
  supervisorLabel: string = "";
  muteNotificationLabel: string = "";
  unmuteNotificationLabel: string = "";
  logoutLabel: string = "";
  serverConnectivityLabel: string = "";
  changeThemeLabel: string = "";

  constructor(public wsService: TrsEventsService, private auditService: AuditService, private translationService: TranslocoService,
    public supervisorService: SupervisorService) { }

  ngOnInit(): void {
    this.userName = this.wsService.supervisorId;

    this.supervisorService.selectedTheme$.subscribe((theme: Themes) => {
      if (theme === 'light')
        document.body.classList.remove('dark');
      else if (theme === 'dark')
        document.body.classList.add('dark');
    });

    this.wsService.evtDataObservable.subscribe(response => {
      switch (response.eventName) {
        case "UPDATE_APP_LABELS":
          this.dashboardLabel = this.translationService.translate("Dashboard");
          this.gamificationLabel = this.translationService.translate("Gamification");
          this.superadminLabel = this.translationService.translate("Super Admin");
          this.supervisorLabel = this.translationService.translate("Supervisor");
          this.muteNotificationLabel = this.translationService.translate("Mute Notification(s)");
          this.unmuteNotificationLabel = this.translationService.translate("Unmute Notification");
          this.logoutLabel = this.translationService.translate("Log Out");
          this.serverConnectivityLabel = this.translationService.translate("Connectivity with Server");
          this.changeThemeLabel = this.translationService.translate("Change Theme");
          break;
        case "SUPERVISORINIT":
          this.supervisorConnectivityStatus = true;
          if (response.data) {
            const supervisorInfo: ISupervisorInit = response.data;

            this.showSuperAdminIcon = supervisorInfo.IsTeamLevelSupervisor === true ? false : true;

            setTimeout(() => {
              this.showLogout = true;
            }, 10000);
          }
          this.userName = this.wsService.supervisorId;
          break;
        case "STEALTHMODE":
          let msg = response.data.ChatMessage;
          if (msg.indexOf("Activated") > -1 || msg.indexOf("Deactivated") > -1) {
            return;
          }
          break;
        case "LOADED_DATA":
          this.isAllDataLoaded = true;
          break;
        case "CALL_INCOMING":
          this.incomingCall = true;
          break;
        case "CALL_DISCONNECTED":
        case "CALL_CONNECTED":
          this.incomingCall = false;
          break;
      }
    });
  }

  changeTheme() {
    this.supervisorService.SetTheme(document.body.classList.contains("dark") === true ? "light" : "dark")
  }

  loadDashBoardView() {
    this.currentProfile = "dashboard";
    this.sendEvent("DASHBOARD_MODE", { 'dashboardView': true });
    this.userMode = 'superadmin';
    this.auditService.AuditSupervisorUsage(19);
  }

  loadGamificationView() {
    this.currentProfile = "gamification";
    this.sendEvent("GAMIFICATION_MODE", { 'gamificationView': true });
    this.userMode = 'superadmin';
    this.auditService.AuditSupervisorUsage(18);
  }

  goback() {
    this.userMode = 'supervisor';
    this.sendEvent("GO_BACK", {});
  }

  loadSuperAdminUI() {
    this.userMode == 'superadmin' ? this.userMode = 'supervisor' : this.userMode = 'superadmin';
    this.currentProfile = this.userMode;
    this.sendEvent("SUPERADMIN_MODE", { teamId: this.wsService.TeamId });
  }

  sendEvent(eventName: any, responseData: any) {
    let data = {
      "eventName": eventName,
      "data": responseData
    };
    this.wsService.evtdata.next(data);
  }

  logout() {
    this.auditService.AuditSupervisorUsage(7);

    if (this.appConfig.settings.SSO.Enabled === true)
      this.sendEvent("LOGOUT-SSO", {});
    else if (this.appConfig.settings.IAM.Enabled === true)
      this.sendEvent("LOGOUT-IAM", {});
    else this.sendEvent("LOGOUT", {});
  }

  toggleSound = (): void => {
    this.isNotificationSoundIconVisible = !this.isNotificationSoundIconVisible;
    toggleNotificationSoundSetting(this.auditService);
  }
}